import { forwardRef } from 'react';

import ConfirmationStep from 'components/SmartGroupFormation/ConfirmationStep';
import CriteriaStep from 'components/SmartGroupFormation/CriteriaStep';
import QuestionnaireStep from 'components/SmartGroupFormation/QuestionnaireStep';

const Mobile = forwardRef((props, ref) => {
    const { STEPS, step } = props;

    return {
        [STEPS[0]]: <CriteriaStep ref={ref} {...props} />,
        [STEPS[1]]: <QuestionnaireStep ref={ref} {...props} />,
        [STEPS[2]]: <ConfirmationStep ref={ref} {...props} />,
    }[step];
});

export default Mobile;
